import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_89039fd3-cb90-48f9-88ab-9d6547dca827/artifacts/ang7mnbh_d04b0c90-39ed-4f51-93a8-9960dfd45601.jpg';

// TikTok Icon Component
const TikTokIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

// YouTube Icon Component
const YouTubeIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-wild-dark text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Wild Ones LLC"
                className="h-16 w-16 object-contain rounded-lg"
              />
              <span className="font-headings text-2xl tracking-wider">
                WILD ONES LLC
              </span>
            </Link>
            <p className="font-body text-wild-stone text-center md:text-left">
              Southern style for the wild at heart.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-headings text-xl tracking-wider mb-6">
              QUICK LINKS
            </h3>
            <nav className="flex flex-col gap-3">
              <Link
                to="/"
                className="font-body text-wild-stone hover:text-white transition-colors"
                data-testid="footer-link-home"
              >
                Home
              </Link>
              <Link
                to="/shop"
                className="font-body text-wild-stone hover:text-white transition-colors"
                data-testid="footer-link-shop"
              >
                Shop
              </Link>
              <Link
                to="/contact"
                className="font-body text-wild-stone hover:text-white transition-colors"
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact & Social */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-headings text-xl tracking-wider mb-6">
              GET IN TOUCH
            </h3>
            <a
              href="tel:8032725881"
              className="flex items-center gap-2 font-body text-wild-stone hover:text-white transition-colors mb-6"
              data-testid="footer-phone"
            >
              <Phone className="h-5 w-5" />
              803-272-5881
            </a>
            <div className="flex items-center gap-4">
              <a
                href="https://www.tiktok.com/@dandhayy"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-wild-stone/20 hover:bg-wild-leather transition-colors"
                aria-label="TikTok"
                data-testid="footer-tiktok"
              >
                <TikTokIcon className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com/@dhaymanzo"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-wild-stone/20 hover:bg-wild-leather transition-colors"
                aria-label="YouTube"
                data-testid="footer-youtube"
              >
                <YouTubeIcon className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-wild-stone/30 mt-12 pt-8">
          <p className="font-body text-sm text-wild-stone text-center">
            &copy; {new Date().getFullYear()} Wild Ones LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
